/**
 * @generated SignedSource<<da2a5f1ea66ce8056799b791d2674896>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "serviceId"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "serviceById",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "target",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nameUk",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "orderItemServiceByIdQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "orderItemServiceByIdQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e8e1e8cbe5def53f60b3c36759886fb1",
    "id": null,
    "metadata": {},
    "name": "orderItemServiceByIdQuery",
    "operationKind": "query",
    "text": "query orderItemServiceByIdQuery(\n  $serviceId: String\n) {\n  serviceById(id: $serviceId) {\n    id\n    name\n    target\n    nameUk\n  }\n}\n"
  }
};
})();

node.hash = "545649b613aa0f79aec9b426dcd59e31";

module.exports = node;
